import { FlexContainer, Icon, Stack, useBreakpointComponent } from "@carrotfertility/carotene"
import React from "react"

export const LogoHeaderBar = (): JSX.Element => {
  const desktopHeader = (
    <FlexContainer style={{ paddingLeft: "140px" }}>
      <Stack
        width="156px"
        height="156px"
        background={"white"}
        style={{ borderRadius: "50%", position: "relative", top: "-36px" }}
        alignItems="center"
        justifyContent="center"
      >
        <Icon color="carrotOrange" name="newLogo" size="112px" title="logo" />
      </Stack>
    </FlexContainer>
  )
  const mobileHeader = (
    <FlexContainer background={"pampas"} height="80px" justifyContent="center">
      <Icon color="carrotOrange" name="newLogo" size="130px" title="logo" />
    </FlexContainer>
  )
  return useBreakpointComponent([mobileHeader, mobileHeader, mobileHeader, desktopHeader]) || <></>
}
